import {EntityDomainModel} from "../../../infrastructure/models/entity/entity.domain-model";
import {CompetitionViewModel} from "../../../domain/common/competition/models/competition-view-model";
import {COMPETITIONS_SLIDER_WIDGET} from "../competition-slider-widget.consts";
import {Type} from "../../../infrastructure/type";
import {CompetitionsSliderTopLogoParams} from "./competitions-slider.top-logo-params";

export class CompetitionsSliderCompetitionViewModel extends CompetitionViewModel {
  apiModel: EntityDomainModel;

  get logoType(): Type {
    return this.id === COMPETITIONS_SLIDER_WIDGET.DEFAULT_COMPETITION_TOP_GAMES_ID ? CompetitionsSliderTopLogoParams : super.logoType;
  }
}
